'use strict';
const React = require('react');

const Pagination = React.createClass({
  propTypes: {
    totalPage: React.PropTypes.number.isRequired,
    selectPage: React.PropTypes.func.isRequired,
  },
  getInitialState() {
    return {
      current: 1,
    };
  },
  componentWillMount() {
    this.setState({ current: parseInt(this.props.startPage, 10) });
  },
  componentWillReceiveProps(props) {
    if (props.startPage === 1) {
      this.setState({ current: 1 });
    } else {
      this.setState({ current: parseInt(props.startPage, 10) });
    }
  },
  _renderPaginate(current) {
    const totalPage = this.props.totalPage;
    const pageArr = [];
    let pageCont = [];
    if (totalPage <= 7) {
      for (let p = 1; p <= totalPage; p++) {
        pageArr.push({
          page: p,
          currentPage: (p === current),
        });
      }
    } else {
      if (current < 4) {
        for (let p = 1; p <= 6; p++) {
          pageArr.push({
            page: p,
            currentPage: (p === current),
          });
        }
        pageArr.push({
          page: '...',
          dot: true,
          currentPage: false,
        });
        pageArr.push({
          page: totalPage,
          currentPage: false,
        });
      } else {
        if ((current - 3) <= 1) {
          for (let i = 1; i <= current; i++) {
            pageArr.push({
              page: i,
              currentPage: (i === current),
            });
          }
        } else {
          pageArr.push({
            page: 1,
            currentPage: false,
          });
          pageArr.push({
            page: '...',
            dot: true,
            currentPage: false,
          });
          if ((totalPage - current) >= 3) {
            for (let j = (current - 2); j <= current; j++) {
              pageArr.push({
                page: j,
                currentPage: (j === current),
              });
            }
          } else {
            for (let j = (current - (5 - (totalPage - current))); j <= current; j++) {
              pageArr.push({
                page: j,
                currentPage: (j === current),
              });
            }
          }
        }
        if ((current + 3) >= totalPage) {
          for (let m = (current + 1); m <= totalPage; m++) {
            pageArr.push({
              page: m,
              currentPage: false,
            });
          }
        } else {
          for (let n = (current + 1); n <= (current + 2); n++) {
            pageArr.push({
              page: n,
              currentPage: false,
            });
          }
          pageArr.push({
            page: '...',
            dot: true,
            currentPage: false,
          });
          pageArr.push({
            page: totalPage,
            currentPage: false,
          });
        }
      }
    }
    pageCont = pageArr.map((item, index) => {
      let pageClass = item.dot ? 'paginate-dot' : '';
      pageClass += item.currentPage ? ' paginate-current' : '';
      return <li className={ pageClass } key={ index }>{ item.page }</li>;
    });
    return pageCont;
  },
  _handlePageClick(e) {
    const target = e.target;
    if (target.tagName !== 'LI' || /paginate-current/.test(target.className) || /paginate-dot/.test(target.className)) return;
    const page = parseInt(target.innerHTML, 10);
    this.setState({
      current: page,
    });
    this.props.selectPage(page);
  },
  _handlePrevClick() {
    const current = parseInt(this.state.current, 10);
    if (current === 1) return;
    this.setState({
      current: (current - 1),
    });
    this.props.selectPage(current - 1);
  },
  _handleNextClick() {
    const current = parseInt(this.state.current, 10);
    if (current === this.props.totalPage) return;
    this.setState({
      current: (current + 1),
    });
    this.props.selectPage(current + 1);
  },

  render() {
    const paginate = this._renderPaginate(this.state.current);
    const prevClass = (this.state.current === 1) ? 'prev-page unavailable' : 'prev-page';
    const nextClass = (this.state.current === this.props.totalPage) ? 'next-page unavailable' : 'next-page';
    return (
        <div id="rq-pagination">
            <span className={ nextClass } onClick={ this._handleNextClick }><i></i></span>
            <ul onClick={ this._handlePageClick }>{ paginate }</ul>
            <span className={ prevClass } onClick={ this._handlePrevClick }><i></i></span>
        </div>
    );
  },
});
module.exports = Pagination;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/element/customPagination.js
 **/